import { RootState } from '@/store/store';
import { GetterTree } from 'vuex';
import { StaticApiState } from './types/static-file.types';

export const staticFileGetters: GetterTree<StaticApiState, RootState> = {};
